module.exports = __webpack_public_path__ + "img/gallery3.38b42114.png";